import React from 'react';
import { _LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import RecommendTagList from '../RecommendTagList';
import RecommendTagListSearchBox from '../RecommendTagListSearchBox';

const RecommendTagListWrap = (props) => {
  const { recommendTagList, setData, getList } = props;

  return (
    <div className="recommend-tag-list-wrap">
      {/* 추천 태그 검색 박스*/}
      <RecommendTagListSearchBox
        setData={(data) =>
          setData({
            path: ['recommendTagList', 'searchData', ...data.path],
            value: data.value,
          })
        }
        searchData={recommendTagList.searchData}
        getList={getList}
      />

      {/* 추천 태그 리스트*/}
      <RecommendTagList
        recommendTagList={recommendTagList.list}
        initialOption={{
          pagination: _LIST_PAGINATION_MODEL,
        }}
        pagination={recommendTagList.pagination}
        getList={getList}
      />
    </div>
  );
};

export default RecommendTagListWrap;
